import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../../../../lib/utils";

function Field({ label, value }: { label: string; value?: ReactNode | string }) {
    const { t } = useTranslation();

    return (
        <div className="tw-flex tw-items-center tw-justify-between tw-text-sm tw-text-muted-foreground tw-mb-2 tw-border-b tw-py-2 last:tw-border-b-0 last:tw-mb-0 sm:[&:nth-last-child(2):nth-child(odd)]:tw-border-b-0 sm:[&:nth-last-child(2):nth-child(odd)]:tw-mb-0">
            <h4>{label}</h4>
            <span className={cn(value ? "tw-text-neutral-900" : "tw-italic")}>
                {!value ? t("not-set") : value}
            </span>
        </div>
    );
}

export default Field;
